import { render, staticRenderFns } from "./RecycleBin.vue?vue&type=template&id=d20970e2&scoped=true"
import script from "./RecycleBin.vue?vue&type=script&lang=js"
export * from "./RecycleBin.vue?vue&type=script&lang=js"
import style0 from "./RecycleBin.vue?vue&type=style&index=0&id=d20970e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20970e2",
  null
  
)

export default component.exports